import { isObject } from "@pineapplelab/util";
import { FBase } from "../FBase";

export class CategoryStatistics extends FBase {

	categoryId: string = null;
	categoryName: string = null;
	quantity: number = null;
	amount: number = null;


	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}

}
export namespace CategoryStatistics {
	export const PATH = 'categoryStatistics';
}
